(() => {
  'use strict';

  const MEDIA = {
    coaching: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-personal-training-coach.jpg?v=1789660033',
    consultation: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-coach-consultation.jpg?v=1789660054',
    strength: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-strength-coaching.jpg?v=1789660045',
    performance: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-performance-training.jpg?v=1789660082',
    shaker: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-post-workout-shaker.jpg?v=1789651618',
    peptides: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-peptides-laboratory.jpg?v=1789652265',
    nutrition: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-nutrition-dark-meal.jpg?v=1789652275',
    health: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-health-wellness.jpg?v=1789652296',
    ptVideo: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-personal-training-video.mp4?v=1789661363',
    trainingVideo: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-coach-training-video.mp4?v=1789661355'
  };

  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function addStyles() {
    if (document.getElementById('mbf-premium-media-style')) return;
    const style = document.createElement('style');
    style.id = 'mbf-premium-media-style';
    style.textContent = `
      .mh-hero.mbf-media-hero{position:relative;isolation:isolate;background:#070708;overflow:hidden}
      .mh-hero.mbf-media-hero::before{content:'';position:absolute;inset:0;background:linear-gradient(90deg,rgba(5,5,7,.95) 0%,rgba(5,5,7,.78) 45%,rgba(5,5,7,.38) 100%);z-index:1;pointer-events:none}
      .mh-hero.mbf-media-hero .mbf-media-bg{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center 42%;z-index:0;opacity:.78;filter:saturate(.78) contrast(1.1) brightness(.72)}
      .mh-hero.mbf-media-hero .mh-hero__in{position:relative;z-index:2}
      .mh-hero.mbf-media-hero.mbf-static-hero{background-image:linear-gradient(90deg,rgba(5,5,7,.95),rgba(5,5,7,.48)),var(--mbf-hero-poster);background-size:cover;background-position:center}
      .ptl-hero__visual.mbf-video-wrap{position:relative;overflow:hidden}
      .ptl-hero__visual.mbf-video-wrap .mbf-coach-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit;opacity:0;transition:opacity .35s ease;background:#08090b}
      .ptl-hero__visual.mbf-video-wrap.mbf-video-ready .mbf-coach-video{opacity:1}
      .ptl-hero__visual.mbf-video-wrap.mbf-video-ready>img{opacity:0}
      .mbf-training-film{background:#09090b;padding:clamp(32px,5vw,72px) 0}
      .mbf-training-film__frame{position:relative;overflow:hidden;border-radius:22px;background:#050506;box-shadow:0 26px 80px rgba(0,0,0,.32)}
      .mbf-training-film video{display:block;width:100%;max-height:760px;aspect-ratio:16/9;object-fit:cover;background:#050506}
      .mbf-training-film__label{position:absolute;left:18px;bottom:18px;z-index:2;padding:9px 12px;border-radius:999px;background:rgba(0,0,0,.62);backdrop-filter:blur(10px);color:#fff;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase}
      .mh-split img,.ptl-hero__visual img,.tp-hero__grid>img{transition:opacity .25s ease}
      @media(max-width:760px){
        .mh-hero.mbf-media-hero::before{background:linear-gradient(180deg,rgba(5,5,7,.58),rgba(5,5,7,.95))}
        .mh-hero.mbf-media-hero .mbf-media-bg{object-position:center}
        .mbf-training-film{padding:28px 0}.mbf-training-film__frame{border-radius:15px}
      }
    `;
    document.head.appendChild(style);
  }

  function setImage(img, src, alt) {
    if (!img) return;
    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (alt) img.alt = alt;
  }

  function replaceImagesBySource(part, src, alt, root) {
    const scope = root || document;
    scope.querySelectorAll(`img[src*="${part}"], img[srcset*="${part}"]`).forEach(img => setImage(img, src, alt));
  }

  function videoEl(src, poster, className) {
    const v = document.createElement('video');
    v.className = className || '';
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.preload = 'metadata';
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('aria-hidden', 'true');
    if (poster) v.poster = poster;
    const s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
    return v;
  }

  function enhanceHome() {
    const hero = document.querySelector('.mh-hero');
    if (hero && !hero.classList.contains('mbf-media-hero')) {
      hero.classList.add('mbf-media-hero');
      if (reduceMotion) {
        hero.classList.add('mbf-static-hero');
        hero.style.setProperty('--mbf-hero-poster', `url("${MEDIA.performance}")`);
      } else {
        const v = videoEl(MEDIA.ptVideo, MEDIA.performance, 'mbf-media-bg');
        v.autoplay = true;
        v.setAttribute('autoplay', '');
        v.addEventListener('error', () => {
          v.remove();
          hero.classList.add('mbf-static-hero');
          hero.style.setProperty('--mbf-hero-poster', `url("${MEDIA.performance}")`);
        }, { once:true });
        hero.insertBefore(v, hero.firstChild);
        const play = v.play();
        if (play && typeof play.catch === 'function') play.catch(() => {});
      }
    }

    const splitImages = document.querySelectorAll('.mh-split img');
    setImage(splitImages[0], MEDIA.consultation, 'Coach consultation and personalized planning — The Muscle Body Factory');
    setImage(splitImages[1], MEDIA.strength, 'Strength and performance training — The Muscle Body Factory');
    replaceImagesBySource('mbf-home-peptides-premium', MEDIA.peptides, 'Research laboratory — The Muscle Body Factory');
    replaceImagesBySource('mbf-home-health-premium', MEDIA.health, 'Health and wellness nutrition — The Muscle Body Factory');
  }

  function enhancePersonalTraining() {
    const wrap = document.querySelector('.ptl-hero__visual');
    const img = wrap && wrap.querySelector('img');
    if (!wrap || !img) return;
    setImage(img, MEDIA.coaching, 'Personal training with a coach — The Muscle Body Factory');
    if (reduceMotion || wrap.querySelector('.mbf-coach-video')) return;
    wrap.classList.add('mbf-video-wrap');
    const v = videoEl(MEDIA.ptVideo, MEDIA.coaching, 'mbf-coach-video');
    v.autoplay = true;
    v.setAttribute('autoplay', '');
    v.addEventListener('loadeddata', () => wrap.classList.add('mbf-video-ready'), { once:true });
    v.addEventListener('error', () => { v.remove(); wrap.classList.remove('mbf-video-ready'); }, { once:true });
    wrap.appendChild(v);
    const play = v.play();
    if (play && typeof play.catch === 'function') play.catch(() => {});
  }

  function enhanceTrainingPlans() {
    const hero = document.querySelector('.tp-hero');
    if (!hero) return;
    const heroImg = hero.querySelector('.tp-hero__grid > img, .tp-hero__grid img');
    setImage(heroImg, MEDIA.strength, 'Strength and performance coaching — The Muscle Body Factory');
    replaceImagesBySource('mbf-service-diet-premium', MEDIA.nutrition, 'Performance nutrition — The Muscle Body Factory');
    replaceImagesBySource('mbf-service-supplement-premium', MEDIA.shaker, 'Sports nutrition and supplement planning — The Muscle Body Factory');
    if (reduceMotion || document.querySelector('.mbf-training-film')) return;

    const section = document.createElement('section');
    section.className = 'mbf-training-film';
    const container = document.createElement('div');
    container.className = 'container';
    const frame = document.createElement('div');
    frame.className = 'mbf-training-film__frame';
    const v = videoEl(MEDIA.trainingVideo, MEDIA.performance, '');
    v.autoplay = true;
    v.setAttribute('autoplay', '');
    const label = document.createElement('span');
    label.className = 'mbf-training-film__label';
    label.textContent = 'MBF · Training & Performance';
    v.addEventListener('error', () => section.remove(), { once:true });
    frame.appendChild(v);
    frame.appendChild(label);
    container.appendChild(frame);
    section.appendChild(container);
    hero.insertAdjacentElement('afterend', section);
    const play = v.play();
    if (play && typeof play.catch === 'function') play.catch(() => {});
  }

  function enhancePeptides() {
    replaceImagesBySource('mbf-home-peptides-premium', MEDIA.peptides, 'Scientific research laboratory — The Muscle Body Factory');
    replaceImagesBySource('mbf-service-peptide', MEDIA.peptides, 'Scientific research laboratory — The Muscle Body Factory');
  }

  function init() {
    addStyles();
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path === '/' || document.querySelector('.mh-hero')) enhanceHome();
    if (path.includes('/pages/personal-training') || document.querySelector('.ptl-hero')) enhancePersonalTraining();
    if (path.includes('/pages/training-plans') || document.querySelector('.tp-hero')) enhanceTrainingPlans();
    if (path.includes('/pages/peptides')) enhancePeptides();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
